module.exports = __webpack_public_path__ + "097feed9b38fcc27460dbf48a018e746.svg";